/**
 * Vehicle Condition / Is Certified / Is Primary radios. Rendered at the very top
 * of the Vehicle Request tab (above the VIN). "Is Certified" only applies to a
 * used vehicle, so it shows only when "Used vehicle" is selected. "Is this
 * Primary Vehicle?" applies to both New and Used and is always shown.
 *
 * @module vehicleModal/components/VehicleConditionSection
 */
import { Form, Radio } from "antd";
import React from "react";
import { SELL_SIDE_INTERESTS } from "../constants";

// Vehicle Condition (new/used) only applies when the customer is buying a
// vehicle. For Sell/Trade/Service the section is hidden entirely.
const HIDE_CONDITION_INTERESTS = SELL_SIDE_INTERESTS;

/**
 * @param {Object} props
 * @param {import("antd").FormInstance} props.form
 * @param {import("../types").CustomerInterest} [props.customerInterest]
 */
export default function VehicleConditionSection({ form, customerInterest }) {
  const condition = Form.useWatch("condition", form);
  const isUsed = condition === "used";

  if (HIDE_CONDITION_INTERESTS.includes(customerInterest)) {
    return null;
  }

  return (
    <div className="flex flex-row flex-wrap gap-x-16 gap-y-4 mb-2">
      <Form.Item name="condition" label="Vehicle Condition" className="mb-0">
        <Radio.Group
          onChange={e => {
            // "Is Certified" only applies to used vehicles. Clear it when
            // switching back to New (where it's hidden) so a stale value isn't
            // saved. Neither field is pre-selected — the user chooses.
            if (e.target.value !== "used") {
              form.setFieldsValue({ isCertified: undefined });
            }
          }}
        >
          <Radio value="new">New vehicle</Radio>
          <Radio value="used">Used vehicle</Radio>
        </Radio.Group>
      </Form.Item>
      {isUsed && (
        <Form.Item name="isCertified" label="Is Certified" className="mb-0">
          <Radio.Group>
            <Radio value>Yes</Radio>
            <Radio value={false}>No</Radio>
          </Radio.Group>
        </Form.Item>
      )}
      <Form.Item name="isPrimary" label="Is this Primary Vehicle?" className="mb-0">
        <Radio.Group>
          <Radio value>Yes</Radio>
          <Radio value={false}>No</Radio>
        </Radio.Group>
      </Form.Item>
    </div>
  );
}
